import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    select: {
      minWidth: 40,
      height: '100%',
      '& .MuiSelect-selectMenu': { height: 'auto' },
      '& .MuiSelect-icon': {
        right: 0,
      },
      '& .MuiSelect-root': {
        fontSize: 11,
        paddingLeft: 8,
        paddingTop: 8,
      },
    },
    smallFontSize: {
      fontSize: 14,
    },
  });
